import { memo } from 'react';
import { Configure, InstantSearch } from 'react-instantsearch-hooks-web';
import { algoliaClient } from '@client/algolia';
import { getAlgoliaIndexName } from '@sda/utils/algolia';
import { Hits } from './Hits';
import { useFilterLocation } from './useFilterLocation.hook';
import type { AlgoliaIndices } from '@sda/enums/algolia';

interface FetchProfilesProps {
  readonly index: AlgoliaIndices;
}

const attributesToRetrieve = [
  '_geoloc',
];

export const FetchProfiles = memo<FetchProfilesProps>(({ index }) => {
  const filterLocation = useFilterLocation();

  return (
    <InstantSearch
      searchClient={algoliaClient}
      indexName={getAlgoliaIndexName(index)}
    >
      <Configure
        hitsPerPage={100}
        attributesToRetrieve={attributesToRetrieve}
        attributesToHighlight={[]}
        {...filterLocation}
      />

      <Hits isExtraHits />
    </InstantSearch>
  );
});
